import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher as MaterialErrorStateMatcher } from '@angular/material/core';

export class ErrorStateMatcher implements MaterialErrorStateMatcher {
	isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
		return control.invalid && (control.dirty || control.touched);
	}
}
